export default "/images/8a4167407112fbf200ed4579c976099d.avif";